/* Nội dung bảng phải Mint-AR 1920: thẻ nền --sub bo 14, padding 14 (code board `dkAn` / `dkTask` / `dkAppr`). */
.sec, .appr { padding: 14px; border-radius: 14px; background: var(--sub); }
.hd { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
.hd h2, .h2 { margin: 0; font-size: 15px; font-weight: var(--fw-title); }
.h2 { margin-bottom: 10px; }
.hd > span { font-size: 12px; color: var(--lb); }
.kpis { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 14px; margin-top: 12px; }
.kpis > div > div { font-size: 12px; color: var(--lb); }
.kpis b { margin-top: 2px; font-size: 22px; font-weight: var(--fw-label); letter-spacing: -0.02em; }
.kpis span { font-size: 12px; color: var(--lb); }
.err { color: var(--err); }
.warn { color: var(--warn); }
.ok { color: var(--ok); }
.tx2 { color: var(--tx2); }
.agRow { display: flex; align-items: center; gap: 12px; }
.agRow svg { flex-shrink: 0; }
.leg { flex-grow: 1; min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.leg > div { display: flex; align-items: center; gap: 6px; height: 21px; font-size: 12px; }
.leg i { width: 8px; height: 8px; flex-shrink: 0; border-radius: 50%; }
.leg span { flex-grow: 1; min-width: 0; white-space: nowrap; color: var(--tx2); }
.leg b { font-weight: var(--fw-label); white-space: nowrap; }
.leg em { width: 30px; text-align: right; font-style: normal; color: var(--lb); }
.trFoot { display: flex; justify-content: space-between; font-size: 12px; color: var(--lb); }
.trFoot b { color: var(--tx); font-weight: var(--fw-label); }
.mask { margin-top: 8px; font-size: 12px; color: var(--lb); }
.topRow { width: 100%; display: grid; grid-template-columns: 96px minmax(0, 1fr) 52px; align-items: center; gap: 8px; height: 30px; padding: 0; border: 0; background: transparent; font: inherit; color: var(--tx); cursor: pointer; text-align: left; white-space: nowrap; }
.topRow > span { overflow: hidden; text-overflow: ellipsis; font-size: 12px; color: var(--tx2); }
.topRow > b { font-size: 12px; font-weight: var(--fw-label); text-align: right; }
.track { height: 8px; border-radius: 4px; background: var(--line); overflow: hidden; }
.track > div { height: 100%; border-radius: 4px; }
.grp { display: flex; justify-content: space-between; padding: 6px 2px; font-size: 12px; font-weight: var(--fw-title); }
.grp span:last-child { font-weight: 500; color: var(--lb); }
.task { display: flex; gap: 10px; padding: 9px 10px; margin-bottom: 6px; border-radius: 12px; background: var(--sub); }
.task input { width: 16px; height: 16px; margin: 2px 0 0; flex-shrink: 0; accent-color: var(--pri); }
.tk { font-weight: 500; }
.code { padding: 1px 6px; margin-right: 6px; border-radius: 6px; background: var(--ctl); font-size: 11px; font-weight: var(--fw-title); color: var(--tx2); }
.due { margin-top: 3px; font-size: 12px; color: var(--lb); }
.appr { display: flex; flex-direction: column; gap: 8px; padding: 12px 14px; }
.appr b { font-weight: var(--fw-label); }
.sub { font-size: 12px; color: var(--lb); }
.why { font-size: 12px; color: var(--tx2); }
.lv { flex-shrink: 0; align-self: flex-start; padding: 3px 8px; border-radius: 999px; font-size: 11px; font-weight: var(--fw-label); background: var(--warn-bg); color: var(--warn); }
.act { height: 30px; padding: 0 10px; border: 0; border-radius: 8px; background: var(--ctl); color: var(--tx); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.act:first-child { background: var(--btn); color: var(--btn-tx); }
